import React, { useState, useEffect } from "react";
import { Modal, TextInput } from "@carbon/react";
import "./addLoginModal.scss";
import { queryClient } from "../..";
import { useTranslation } from "react-i18next";
import { useAddToFarm } from "../../hooks/useAddToFarm";

export default function AddLoginModal({
  openModal,
  setOpenModal,
}) {
  const { t } = useTranslation();
  const [value, setValue] = useState("");
  const [validation, setValidation] = useState({
    invalid: false,
    invalidText: "",
  });

  const mutationBind = useAddToFarm();
  const loginRegex =
    /^([A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}|\+[0-9]{5,48})$/;

  useEffect(() => {
    if (value && !loginRegex.test(value.trim())) {
      setValidation({
        invalid: true,
        invalidText: t("admin.modalText.validation.loginValidation"),
      });
    } else {
      setValidation({ invalid: false, invalidText: "" });
    }
  }, [value, t]);

  const handleAddLogin = () => {
    if (validation.invalid) return;

    if (!value.trim()) {
      setValidation({
        invalid: true,
        invalidText: t("admin.modalText.validation.noValue"),
      });
      return;
    }

    mutationBind.mutate(
      { login: value },
      {
        onSuccess: (data) => {
          queryClient.invalidateQueries({ queryKey: ["farm-list"] });
          setOpenModal(false);
          setValue("");
        },
      }
    );
  };

  return (
    <Modal
      open={!!openModal}
      onRequestClose={() => setOpenModal(false)}
      modalLabel={`${t("admin.modalText.label")}`}
      modalHeading={`${t("admin.modalText.title")}`}
      primaryButtonText={`${t("admin.modalText.add")}`}
      secondaryButtonText={`${t("admin.modalText.cancel")}`}
      onRequestSubmit={handleAddLogin}
      onSecondarySubmit={() => setOpenModal(false)}
      closeButtonLabel={`${t("admin.modalText.close")}`}
    >
      <TextInput
        id="text-input-1"
        labelText={`${t("admin.modalText.labelText")}`}
        placeholder={`${t("admin.modalText.placeholder")}`}
        helperText={`${t("admin.modalText.description")}`}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        required
        invalid={validation.invalid}
        invalidText={validation.invalidText ? validation.invalidText : ""}
      />
    </Modal>
  );
}
